<div class="basic-editor-wrap">
  <div #gjsRef class="gjs-container"></div>
</div>